import { SVGProps } from 'react';

export const SvgProducts = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      d="M17.5 13.3333V6.66667C17.4997 6.37441 17.4225 6.08736 17.2763 5.83426C17.13 5.58117 16.9198 5.37094 16.6667 5.225L10.8333 1.89167C10.5797 1.74523 10.2924 1.66797 10 1.66797C9.70761 1.66797 9.42029 1.74523 9.16667 1.89167L3.33333 5.225C3.08022 5.37094 2.86998 5.58117 2.72372 5.83426C2.57745 6.08736 2.5003 6.37441 2.5 6.66667V13.3333C2.5003 13.6256 2.57745 13.9126 2.72372 14.1657C2.86998 14.4188 3.08022 14.6291 3.33333 14.775L9.16667 18.1083C9.42029 18.2548 9.70761 18.332 10 18.332C10.2924 18.332 10.5797 18.2548 10.8333 18.1083L16.6667 14.775C16.9198 14.6291 17.13 14.4188 17.2763 14.1657C17.4225 13.9126 17.4997 13.6256 17.5 13.3333Z"
      stroke="currentColor"
      strokeWidth={1.2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.72461 5.8L9.99961 10.0083L17.2746 5.8"
      stroke="currentColor"
      strokeWidth={1.2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 18.4V10"
      stroke="currentColor"
      strokeWidth={1.2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
